import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Card, FormControl, Grid, InputLabel, MenuItem, Select, Switch, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import { Link, Navigate } from "react-router-dom";

export default class Topics extends Component {
  state = {
    allJobs: [],
    allSubjects: [],
    selectedSubjectId: "",
    togglingArIds: {},
    togglingAgriBoostIds: {},
    message: "",
    notification: false,
    noticolor: "success",
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      nextPage: null,
      prevPage: null,
      totalDocs: 0,
      limit: 20,
    },
    per_page: 20,
    page_no: 1,
    redirect: false,
  };
  componentDidMount() {
    this.getSubjectOptions();
    this.getAllTopics(this.state.page_no, this.state.per_page);
  }

  buildTopicListUrl = (pathname, topic) => {
    const params = new URLSearchParams();
    const subjectId = topic?.subject_id?._id || topic?.subject_id;

    if (subjectId) params.set("subject_id", subjectId);
    if (topic?._id) params.set("topic_id", topic._id);
    if (topic?.topic_name) params.set("topic_name", topic.topic_name);

    return `${pathname}?${params.toString()}`;
  };

  getAllTopics = (page, limit) => {
    if (init() === "success") {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });

      if (this.state.selectedSubjectId) {
        params.append("subject_id", this.state.selectedSubjectId);
      }

      axios
        .get(`${Constants.getUrls.getAllTopics}?${params.toString()}`)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              allJobs: resp.data.data.docs,
              pagination: resp.data.data, // whole pagination object from backend
              page_no: resp.data.data.page,
              notification: true,
              noticolor: "success",
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState({ notification: false, message: "" });
            }, 2500);
          } else {
            this.setState({
              notification: true,
              noticolor: "error",
              message: resp.data.message,
            });
          }
        })
        .catch((err) => {
          this.setState({
            notification: true,
            noticolor: "error",
            message: err.response?.message || "Error fetching questions",
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 2500);
        });
    } else {
      window.location.assign("/signin");
    }
  };

  getSubjectOptions = () => {
    if (init() === "success") {
      axios
        .get(`${Constants.getUrls.getAllSubjects}?page=1&limit=500`)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              allSubjects: resp?.data?.data?.docs || [],
            });
          }
        })
        .catch(() => {
          this.setState({
            allSubjects: [],
          });
        });
    }
  };

  handleEntriesPerPageChange = (newLimit) => {
    this.setState({ per_page: newLimit }, () => {
      this.getAllTopics(1, newLimit); // reset to first page with new limit
    });
  };

  // ✅ Handle page change (from DataTable)
  handlePageChange = (newPage) => {
    this.getAllTopics(newPage, this.state.per_page);
  };

  handleSubjectFilterChange = (event) => {
    const selectedSubjectId = event.target.value;
    this.setState(
      {
        selectedSubjectId,
        page_no: 1,
      },
      () => {
        this.getAllTopics(1, this.state.per_page);
      }
    );
  };

  handleArToggle = (id) => {
    if (init() === "success") {
      this.setState(
        (prevState) => ({
          togglingArIds: {
            ...prevState.togglingArIds,
            [id]: true,
          },
        }),
        () => {
          axios
            .put(Constants.putUrls.toggleTopicAr + id)
            .then((resp) => {
              this.setState({
                notification: true,
                noticolor: resp?.data?.status === "success" ? "success" : "error",
                message: resp?.data?.message || "AR status updated.",
              });
              this.getAllTopics(this.state.page_no, this.state.per_page);
            })
            .catch((err) => {
              this.setState({
                notification: true,
                noticolor: "error",
                message: err?.response?.data?.message || "Unable to update AR status.",
              });
            })
            .finally(() => {
              this.setState((prevState) => ({
                togglingArIds: {
                  ...prevState.togglingArIds,
                  [id]: false,
                },
              }));
              setTimeout(() => {
                this.setState({ notification: false, message: "" });
              }, 2500);
            });
        }
      );
    } else {
      window.location.assign("/");
    }
  };

  handleAgriBoostToggle = (id) => {
    if (init() === "success") {
      this.setState(
        (prevState) => ({
          togglingAgriBoostIds: {
            ...prevState.togglingAgriBoostIds,
            [id]: true,
          },
        }),
        () => {
          axios
            .put(Constants.putUrls.toggleTopicAgriBoost + id)
            .then((resp) => {
              this.setState({
                notification: true,
                noticolor: resp?.data?.status === "success" ? "success" : "error",
                message: resp?.data?.message || "AgriBoost status updated.",
              });
              this.getAllTopics(this.state.page_no, this.state.per_page);
            })
            .catch((err) => {
              this.setState({
                notification: true,
                noticolor: "error",
                message: err?.response?.data?.message || "Unable to update AgriBoost status.",
              });
            })
            .finally(() => {
              this.setState((prevState) => ({
                togglingAgriBoostIds: {
                  ...prevState.togglingAgriBoostIds,
                  [id]: false,
                },
              }));
              setTimeout(() => {
                this.setState({ notification: false, message: "" });
              }, 2500);
            });
        }
      );
    } else {
      window.location.assign("/");
    }
  };

  handleDelete = (id) => {
    if (init() === "success") {
      axios
        .delete(Constants.deleteUrls.deleteTopic + id)
        .then((resp) => {
          if (resp.data.status === "success") {
            this.setState({
              notification: true,
              message: resp.data.message,
            });
            setTimeout(() => {
              this.setState(
                {
                  notification: false,
                  message: "",
                },
                () => {
                  this.getAllTopics(this.state.page_no, this.state.per_page);
                }
              );
            }, 2500);
          }
        })
        .catch((err) => {
          //   console.log(err);
          this.setState({
            notification: true,
            message: err.response?.message,
          });
          setTimeout(() => {
            this.setState(
              {
                notification: false,
                message: "",
              },
              () => {
                this.getAllTopics(this.state.page_no, this.state.per_page);
              }
            );
          }, 2500);
        });
    } else {
      window.location.assign("/");
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/signin" replace={true} />;
    } else {
      return (
        <div>
          <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
              <Card>
                <MDBox
                  mx={2}
                  mt={-3}
                  py={3}
                  px={2}
                  variant="gradient"
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                >
                  <MDTypography variant="h6" color="white">
                    Topic List
                  </MDTypography>
                </MDBox>
                <MDBox px={2} py={2}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={4}>
                      <InputLabel shrink>Filter By Subject</InputLabel>
                      <FormControl fullWidth>
                        <Select
                          value={this.state.selectedSubjectId}
                          onChange={this.handleSubjectFilterChange}
                          displayEmpty
                        >
                          <MenuItem value="">All Subjects</MenuItem>
                          {this.state.allSubjects.map((subject) => (
                            <MenuItem key={subject._id} value={subject._id}>
                              {subject.subject_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={8} align="right">
                      <Link to="/addTopic">
                        <MDButton variant="contained" size="small" color="primary">
                          Create
                        </MDButton>
                      </Link>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox>
                  <DataTable
                    table={{
                      columns: [
                        { Header: "serial", accessor: "serial", width: "6%" },
                        { Header: "name", accessor: "name" },
                        { Header: "subject", accessor: "subject" },
                        { Header: "AR", accessor: "ar_enabled" },
                        { Header: "AgriBoost", accessor: "agriboost_enabled" },
                        { Header: "Topic Content", accessor: "topic_content" },
                        // { Header: "image", accessor: "image" },
                        { Header: "action", accessor: "action" },
                      ],
                      rows: this.state.allJobs.map((job, index) => ({
                        serial:
                          (Number(this.state.pagination?.page || 1) - 1) *
                            Number(this.state.per_page || 20) +
                          index +
                          1,
                        name: job.topic_name,
                        subject: job?.subject_id?.subject_name,
                        ar_enabled: (
                          <Switch
                            checked={job.ar_enabled !== false}
                            disabled={Boolean(this.state.togglingArIds[job._id])}
                            onChange={() => this.handleArToggle(job._id)}
                            color="success"
                          />
                        ),
                        agriboost_enabled: (
                          <Switch
                            checked={job.agriboost_enabled !== false}
                            disabled={Boolean(this.state.togglingAgriBoostIds[job._id])}
                            onChange={() => this.handleAgriBoostToggle(job._id)}
                            color="success"
                          />
                        ),
                        topic_content: (
                          <MDBox display="flex" flexDirection="column" gap={1} minWidth="145px">
                            <Link to={this.buildTopicListUrl("/questions", job)}>
                              <MDButton variant="outlined" size="small" color="info" fullWidth>
                                MCQ Questions
                              </MDButton>
                            </Link>
                            <Link to={this.buildTopicListUrl("/ar-questions", job)}>
                              <MDButton variant="outlined" size="small" color="warning" fullWidth>
                                AR Questions
                              </MDButton>
                            </Link>
                            <Link to={this.buildTopicListUrl("/agriboost", job)}>
                              <MDButton variant="outlined" size="small" color="success" fullWidth>
                                AgriBoost
                              </MDButton>
                            </Link>
                          </MDBox>
                        ),
                        // image: (
                        //   <>
                        //     <img src={Constants.imageDomain + job.subject_poster} height="100px" />
                        //   </>
                        // ),
                        // content: job.content,

                        action: (
                          <>
                            <div>
                              <Link
                                to={{
                                  pathname: "/updateTopic/" + job._id,
                                  state: { data: job },
                                }}
                              >
                                <MDButton variant="outlined" size="small" color="success">
                                  Update
                                </MDButton>
                              </Link>
                            </div>
                            <div style={{ marginTop: "1rem" }}>
                              <MDButton
                                variant="outlined"
                                size="small"
                                color="error"
                                onClick={() => this.handleDelete(job._id)}
                              >
                                Delete
                              </MDButton>
                            </div>
                          </>
                        ),
                      })),
                    }}
                    entriesPerPage={{ defaultValue: this.state.per_page, entries: [10, 25, 50, 100] }}
                    page_no={this.state.pagination?.page}
                    totalPages={this.state.pagination?.totalPages}
                    hasNextPage={this.state.pagination?.hasNextPage}
                    hasPrevPage={this.state.pagination?.hasPrevPage}
                    isnextPage={this.state.pagination?.nextPage}
                    prevPage={this.state.pagination?.prevPage}
                    totalDocs={this.state.pagination?.totalDocs}
                    onPageChange={this.handlePageChange}
                    onEntriesPerPageChange={this.handleEntriesPerPageChange}
                  />
                </MDBox>
                <>
                  <MDSnackbar
                    color={this.state.noticolor}
                    icon="notifications"
                    title="AgriQuiz"
                    content={this.state.message}
                    dateTime="Just now"
                    open={this.state.notification}
                    //   close={toggleSnackbar}
                  />
                </>
              </Card>
            </MDBox>
          </DashboardLayout>
        </div>
      );
    }
  }
}
